function parseBrazilianPrice(str) {
    return parseFloat(
        str
            .replace(/\./g, '')
            .replace(',', '.')
    );
}

function formatToBRL(value) {
    return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
}

document.addEventListener('DOMContentLoaded', () => {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
        const { target } = data
        const variantPrice = target.dataset.variantPrice;
        const variantQtdParcelas = target.dataset.variantQtdParcela;
        const variantPix = target.dataset.variantPix;

        const parcela = document.querySelector('#parcela')
        const pixProduct = document.querySelector('#pix-produto')
        const pixDesconto = document.querySelector('#pix-desconto')
        const fullPrice = document.querySelector('#full-price-product')

        const priceNumber = parseBrazilianPrice(variantPrice);
        const installmentCount = parseInt(variantQtdParcelas, 10);
        const installmentValue = priceNumber / installmentCount;

        const discountPercentage = parseFloat(
            variantPix.replace(',', '.')
        ) || 0;

        const discountValueNumber = priceNumber * (discountPercentage / 100);
        const finalPriceNumber = priceNumber - discountValueNumber;

        const fullPriceValueFormatted = formatToBRL(priceNumber);
        const installmentValueFormatted = formatToBRL(installmentValue);
        const discountValueFormatted = formatToBRL(discountValueNumber);
        const finalPriceFormatted = formatToBRL(finalPriceNumber);

        if(fullPrice) fullPrice.textContent = fullPriceValueFormatted
        if (parcela) parcela.textContent = installmentValueFormatted
        if (pixProduct) pixProduct.textContent = finalPriceFormatted;
        if (pixDesconto) pixDesconto.textContent = `Pague com pix e economize ${discountValueFormatted}`
    });
});